import { createCRUDHook } from './createCRUDHook';
import { PersonalBestDto } from 'utils/models';
import { TBL_STAFF_PERSONAL_BEST } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<PersonalBestDto>({
  entityName: 'PersonalBest',
  endpoint: TBL_STAFF_PERSONAL_BEST,
});

export const PersonalBestContext = Context;
export const usePersonalBestManager = useManager;
export const usePersonalBest = useConsumer;
